import TSAbstractEntity from './TSAbstractEntity';
import TSBankverbindung from './TSBankverbindung';
import {TSSerializable} from './TSSerializable';

export default class TSFinanzangabenDaten extends TSAbstractEntity implements TSSerializable<TSFinanzangabenDaten> {

    private _steuerjahr: number;

    private _einkommenGewinn: number;

    private _vermoegenKapital: number;

    private _bankverbindung: TSBankverbindung | undefined;

    constructor() {
        super();
        this.bankverbindung = new TSBankverbindung();
    }

    public get steuerjahr(): number {
        return this._steuerjahr;
    }

    public set steuerjahr(value: number) {
        this._steuerjahr = value;
    }

    public get einkommenGewinn(): number {
        return this._einkommenGewinn;
    }

    public set einkommenGewinn(value: number) {
        this._einkommenGewinn = value;
    }

    public get vermoegenKapital(): number {
        return this._vermoegenKapital;
    }

    public set vermoegenKapital(value: number) {
        this._vermoegenKapital = value;
    }

    public get bankverbindung(): TSBankverbindung | undefined {
        return this._bankverbindung;
    }

    public set bankverbindung(value: TSBankverbindung | undefined) {
        this._bankverbindung = value;
    }

    deserialize(restObject: any): TSFinanzangabenDaten {
        super.deserialize(restObject);
        this.einkommenGewinn = restObject.einkommenGewinn;
        this.steuerjahr = restObject.steuerjahr;
        this.vermoegenKapital = restObject.vermoegenKapital;
        this.bankverbindung = this.deserializeOrCreate(restObject.bankverbindung, new TSBankverbindung());

        return this;
    }

    public static getDeserializer = (finanzangabenDaten: any) => {
        return new TSFinanzangabenDaten().deserialize(finanzangabenDaten);
    };

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.einkommenGewinn = this.einkommenGewinn;
        restObject.steuerjahr = this.steuerjahr;
        restObject.vermoegenKapital = this.vermoegenKapital;
        restObject.bankverbindung = this.serializeOrInit(this.bankverbindung, restObject.bankverbindung);
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSFinanzangabenDaten.ts